<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>Nome</th>
          <th class="text-center">Status</th>
          <th>Criado por</th>
          <th>Atualizado por</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="group in groups" :key="group.id">
          <td class="text-center">{{ group.id }}</td>
          <td>{{ group.name }}</td>
          <td v-html="statusTranslate(group.status)" class="text-center" />
          <td>
            {{ createdUpdatedUser(group.createdBy, group.createdAt) }}
          </td>
          <td>
            {{ createdUpdatedUser(group.updatedBy, group.updatedAt) }}
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon"
              title="Excluir"
              @click="$emit('deleteGroup', group.id)"
            >
              <i class="ph ph-trash" />
            </button>
            <button
              type="button"
              class="btn btn-outline-warning btn-icon ms-2"
              title="Editar"
              @click="$emit('createEditGroup', group.id)"
            >
              <i class="ph ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListGroups',

  props: {
    groups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListGroups',
        columnDefs: [
          {
            targets: [3, 4, 5],
            orderable: false,
          },
          {
            targets: [5],
            width: 120,
          },
        ],
      },
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
